// Row indentation for the nested location dropdowns, keyed by tree depth. Top-level region rows
// sit flush; every deeper row indents past its parent's expand chevron so the hierarchy reads.
const TOP_LEVEL_COUNTRY_INDENT_PX = 16;
const NESTED_ROW_INDENT_PX = 28;

const indentLeft = (indentPx: number): string => `0 0 0 ${indentPx}px`;

export const getRegionRowPadding = (depth: number): string =>
    depth <= 0 ? "0" : indentLeft(depth * NESTED_ROW_INDENT_PX);

export const getCountryOptionPadding = (depth: number): string => {
    if (depth <= 0) {
        return indentLeft(TOP_LEVEL_COUNTRY_INDENT_PX);
    }

    return indentLeft(depth * NESTED_ROW_INDENT_PX);
};
